/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of workshop attendance.
 * @export
 */
export const AttendanceStatus = {
    Registered: 'registered',
    CheckedIn: 'checked_in',
    Absent: 'absent',
    Excused: 'excused'
} as const;
export type AttendanceStatus = typeof AttendanceStatus[keyof typeof AttendanceStatus];


export function instanceOfAttendanceStatus(value: any): boolean {
    for (const key in AttendanceStatus) {
        if (Object.prototype.hasOwnProperty.call(AttendanceStatus, key)) {
            if (AttendanceStatus[key as keyof typeof AttendanceStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AttendanceStatusFromJSON(json: any): AttendanceStatus {
    return AttendanceStatusFromJSONTyped(json, false);
}

export function AttendanceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttendanceStatus {
    return json as AttendanceStatus;
}

export function AttendanceStatusToJSON(value?: AttendanceStatus | null): any {
    return value as any;
}

export function AttendanceStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): AttendanceStatus {
    return value as AttendanceStatus;
}

